import React from 'react';

export const NoDefaultConnectionMessage: React.FC = () => (
  <div title="No default connection defined">
    <h2 className="connect-message-title">No default connection defined</h2>
    <p>
      Unable to connect to the subscription because no default URLs have been set for this
      subscription.
    </p>
  </div>
);
